import React, { useRef, useState, useEffect } from 'react'
import './Categorydescription.css'
import '../../../Pages/Page/GeneralPage.css';
import CMSHead from '../../UI-Controls/CMSHead/CMSHead';
import { security_key, Url,configEditor_upd } from '../../../Services/Api';
import axios from 'axios';
import { IoClose } from "react-icons/io5";
import { useLocation } from 'react-router-dom';
import ImageGalleryPopup from '../../UI-Controls/PopUp/ImageGalleryPapup/ImageGalleryPopup';
import { uploadImage } from '../../../Services/functions';
import JoditEditor from "jodit-react";
import '../../../../src/JoditEditorStyle.css';
import GalleryUpload from '../../UI-Controls/GalleryUpload/GalleryUpload';

const CategoryDescription = () => {

  const editor = useRef(null);
  const [modalView, setModalView] = useState(false)
  const [uploadedStatus, setUploadedStates] = useState('');
  const [mediaDeta, setMediaData] = useState([])
  const [imageSendPayload, setImageSendPayload] = useState({
    file: null,
    alt_text: '',
    title: '',
    description: '',
    usedin: [],
    link_url: '',
  });
  const [currentModalIndex, setCurrentModalIndex] = useState(null)
  const [combinedState, setCombinedState] = useState([]);
  const [selectedTab, setSelectedTab] = useState("Visual");

  const location = useLocation()
  const subCategoryData = location.state

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const api = `${Url}/api/v1/media/global/add`

    if (file) {
      setImageSendPayload((prevData) => ({
        ...prevData,
        file: file,
      }));
      setUploadedStates('loading');
      const imagePayloadToSend = new FormData();
      imagePayloadToSend.append('image', file);
      imagePayloadToSend.append('alt_text', imageSendPayload.alt_text);
      imagePayloadToSend.append('title', imageSendPayload.title);
      imagePayloadToSend.append('description', imageSendPayload.description);
      imagePayloadToSend.append('image_url', imageSendPayload.image_url);
      imagePayloadToSend.append('link_url', imageSendPayload.link_url);
      try {
        await uploadImage(imagePayloadToSend, api, setUploadedStates);
        setUploadedStates('success');
        getApi()
      } catch (error) {
        console.error("Image upload failed:", error);
        setUploadedStates('error');
      }
    }
  }

  const getApi = async () => {
    try {
      const response = await axios.get(`${Url}/api/v1/media/global/get`)
      setMediaData(response.data.media)
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getApi();
  }, []);

  useEffect(() => {
    const fetchEditorContent = async () => {
      const api = `/api/v1/sub-category/get`;
      try {
        const response = await axios.get(`${Url + api}/${subCategoryData.slug}`);
        const apiData = response.data;
        setCombinedState(apiData)

      } catch (error) {
        console.error("error geting content", error)
      }
    }
    fetchEditorContent()
  }, [])

  useEffect(() => { console.log("combined state data", combinedState) }, [combinedState])

  /* --- Jodit Editor Configuration --- */
  // const configEditor = {
  //   buttons: [
  //     "bold",
  //     "italic",
  //     "underline",
  //     "strikethrough",
  //     "|",
  //     "paragraph",
  //     "fontsize",
  //     "lineHeight",
  //     "|",
  //     "ul",
  //     "ol",
  //     "|",
  //     "|",
  //     "align",
  //     "undo",
  //     "redo",
  //   ],
  //   style: {
  //     fontFamily: "var(--font-family)",
  //     fontSize: "var(--font-size-small)",
  //     lineHeight: "1.6",
  //     color: "var(--text-color-1)",
  //     height: "400px",
  //   },
  //   toolbarAdaptive: false,
  //   toolbarSticky: false,

  // };


  const configEditor = {
    buttons: [
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "|",
      "paragraph",
      "fontsize",
      "lineHeight",
      "|",
      "ul",
      "ol",
      "|",
      "align",
      "undo",
      "redo",
    ],
    style: {
      fontFamily: "var(--font-family)",
      fontSize: "var(--font-size-small)",
      lineHeight: "1.6",
      color: "var(--text-color-1)",
      height: "400px",
    },
    toolbarAdaptive: false,
    toolbarSticky: false,

    // 👇 Force plain text only
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    pastePlain: true, // ✅ this is the key
    cleanHTML: {
      cleanOnPaste: true,   // clean pasted HTML
      removeStyles: true,   // ✅ remove all inline styles
      removeClasses: true,  // ✅ remove class names
    },
  };


  const handleEditorOnChange = (newContent) => {
    setCombinedState((prevState) => ({
      ...prevState,
      slugName: subCategoryData.slug,
      content: newContent
    }));
  };

  const handleDeleteImage = (index) => {
    setCombinedState((prevState) => {
      const updatedContentImages = [...prevState.content_images];

      updatedContentImages[index] = {
        ...updatedContentImages[index],
        image_url: '',
      };

      return {
        ...prevState,
        content_images: updatedContentImages,
      };
    });
  }

  const handleOpenModal = (index) => {
    setModalView(true)
    setCurrentModalIndex(index)
  }

  const handleModalClose = () => {
    setModalView(false)
    setCurrentModalIndex(null)
  }

  const handleImageSelect = (image) => {
    setCombinedState((prevState) => {
      const updatedContentImages = [...prevState.content_images];
      updatedContentImages[currentModalIndex] = {
        ...updatedContentImages[currentModalIndex],
        image_url: image.image_url
      };

      return {
        ...prevState,
        content_images: updatedContentImages
      };
    });
    setModalView(false)
  };

  const handleDescriptionSet = async () => {
    const api = `/api/v1/sub-category/edit`
    const token = sessionStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`,
      'x-api-key': security_key
    };
    const payload = {
      content: combinedState.content,
      content_images: combinedState.content_images,
      slugName: subCategoryData.slug
    };
    try {
      const response = await axios.put(`${Url + api}`, payload, { headers: headers });
      console.log("category description", response)
    } catch (error) {
      console.error("error updating description", error);
    }
  }

  return (
    <div className='category-description-main-section'>
      <CMSHead
        heading={'Category Description'}
        buttonText={'Save'}
        isButtonVissible={true}
        sendImagesHomeSlider={handleDescriptionSet}
      />

      <div className='category-description-body'>
        <div className='category-editer-section'>
          <div className="custom-editor-pageSection">

            <div className="Policy-Editor">
              <div className="Editor-Row">
                <div className="General-Editor-Container">
                  <div className="General-Editor-Tabs">
                    <div
                      className={`Tab ${selectedTab === "Visual" ? "active" : ""}`}
                      onClick={() => setSelectedTab("Visual")}
                    >
                      Visual
                    </div>
                    <div
                      className={`Tab ${selectedTab === "Text" ? "active" : ""}`}
                      onClick={() => setSelectedTab("Text")}
                    >
                      Text
                    </div>
                  </div>

                  <div className="General-Editor-Content">
                    {selectedTab === "Visual" ? (
                      <JoditEditor
                        ref={editor}
                        value={combinedState.content}
                        tabIndex={1}
                        onBlur={(newContent) => handleEditorOnChange(newContent)}
                        config={configEditor_upd}
                      />
                    ) : (
                      <textarea
                        id="contentDescription"
                        name="contentDescription"
                        value={combinedState.content}
                        onChange={(e) =>
                          setCombinedState((prev) => ({
                            ...prev,
                            content: e.target.value,
                          }))
                        }
                        className="General-Editor-Text-Area"
                        placeholder="Content Description"
                      />

                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className='category-description-images-container'>
          {Array.from({ length: 10 }).map((_, index) => {
            const item = combinedState?.content_images?.[index];
            return item && item.image_url ? (
              <div className='category-description-single-image' key={index}>
                <button className='category-description-img-dlt-btn' onClick={() => handleDeleteImage(index)}>
                  <IoClose size={15} color='#595959' />
                </button>
                <img src={`${Url + item.image_url}`} alt='item' />
              </div>
            ) : (
              <GalleryUpload
                openModal={() => handleOpenModal(index)}
                fontSize='8px'
                width='100%'
              />
            );
          })}
        </div>
      </div>

      <ImageGalleryPopup
        showImageGalleryPopUp={modalView}
        handleModalView={handleModalClose}
        onImageSelect={handleImageSelect}
        imageSendPayload={imageSendPayload}
        setImageSendPayload={setImageSendPayload}
        alt_text={imageSendPayload.alt_text}
        title={imageSendPayload.title}
        handleFileChange={handleFileChange}
        data={mediaDeta}
        getData={getApi}
        editGalleryImageApi={'/api/v1/media/global/'}
      />

    </div>
  )
}

export default CategoryDescription